import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "../i18n/I18nContext";
import { getDebtReportPdf } from "../services/reports";
import { listFrequencies } from "../services/teacher";
import { MONTHS, monthName } from "../utils/paymentHelpers";
import MultiSelectField from "./shared/MultiSelectField";
import { levelKey } from "../utils/classesLabels";

const currentYear = new Date().getFullYear();
const YEAR_OPTIONS = Array.from({ length: currentYear + 1 - 2024 + 1 }, (_, i) => 2024 + i);

const RelatorioDividasLayer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [year, setYear] = useState(currentYear);
  const [selectedMonths, setSelectedMonths] = useState([]);
  const [type, setType] = useState("");
  const [courseId, setCourseId] = useState("");
  const [frequencies, setFrequencies] = useState([]);
  const [generating, setGenerating] = useState(false);

  useEffect(() => {
    listFrequencies().then((resp) => setFrequencies(resp.data || [])).catch(() => setFrequencies([]));
  }, []);

  const handleGenerate = async () => {
    setGenerating(true);
    try {
      const resp = await getDebtReportPdf({ year, months: selectedMonths, type, courseId });
      const monthsLabel = selectedMonths.length ? selectedMonths.map(monthName).join(", ") : year;
      navigate("/documentos/pdf", {
        state: {
          url: resp.data.pdf,
          title: t("relatorioDividas.documento.title", { period: monthsLabel }),
          filename: `relatorio-dividas-${year}.pdf`,
        },
      });
    } catch (err) {
      toast.error(t("relatorioDividas.error.generate"));
    } finally {
      setGenerating(false);
    }
  };

  return (
    <div className='row gy-4'>
      <ToastContainer />

      <div className='col-12'>
        <div className='card radius-12'>
          <div className='card-body'>
            <div className='row gy-3'>
              <div className='col-sm-3'>
                <label className='form-label'>{t("turma.field.academicYear")}</label>
                <select className='form-select' value={year} onChange={(e) => setYear(Number(e.target.value))}>
                  {YEAR_OPTIONS.map((y) => (
                    <option key={y} value={y}>
                      {y}
                    </option>
                  ))}
                </select>
              </div>
              <div className='col-sm-3'>
                <label className='form-label'>{t("relatorioDividas.field.type")}</label>
                <select className='form-select' value={type} onChange={(e) => setType(e.target.value)}>
                  <option value=''>{t("relatorioDividas.type.propinas")}</option>
                  <option value='extra'>{t("relatorioDividas.type.extras")}</option>
                </select>
              </div>
              <div className='col-sm-3'>
                <label className='form-label'>{t(levelKey("taxa.field.course"))}</label>
                <select className='form-select' value={courseId} onChange={(e) => setCourseId(e.target.value)}>
                  <option value=''>{t(levelKey("taxa.field.course.allLevels"))}</option>
                  {frequencies.map((f) => (
                    <option key={f.id} value={f.id}>
                      {f.description}
                    </option>
                  ))}
                </select>
              </div>
              <div className='col-sm-3 d-flex align-items-end'>
                <button type='button' className='btn btn-primary-600 w-100' onClick={handleGenerate} disabled={generating}>
                  {generating ? t("global.loading") : (<><i className='ri-file-chart-line' /> {t("relatorioDividas.action.generate")}</>)}
                </button>
              </div>
              <div className='col-12'>
                <label className='form-label'>{t("relatorioDividas.field.months")}</label>
                <MultiSelectField
                  items={MONTHS}
                  getOptionValue={(m) => Number(m.code)}
                  getOptionLabel={(m) => m.desc}
                  selectedIds={selectedMonths}
                  onChange={setSelectedMonths}
                  placeholder={t("relatorioDividas.field.months.placeholder")}
                  noOptionsMessage='-'
                />
                <span className='text-secondary-light text-sm'>{t("relatorioDividas.hint.allMonths")}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RelatorioDividasLayer;
